jQuery(function ($) {
  $("body").on(
    "click",
    '.pagination a:not(".pagination--noajax a")',
    function (e) {
      e.preventDefault();
      var link = encodeURI($(this).attr("href"));

      // Show the loading overlay
      $(".loading-overlay").show();

      // If a pagination link is below the content scroll up
      if ($(this).parents(".pagination-bottom").length) {
        $.scrollTo("#ajax-archive", 500, { offset: -150 });
      }
      // Make the call
      $("#ajax-archive").load(
        link + " #ajax-archive",
        function (response, status, xhr) {
          if (status == "success") {
            // Hide the overlay on success
            $(".loading-overlay").hide();
            // Push the browser history state
            var stateObj = { state: "ready" };
            var page_title = $(document).find("title").text();
            history.pushState(stateObj, page_title, link);
          }
        }
      );
    }
  );
});
